import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ResponsiveImage from './ResponsiveImage';
import BadgeRow from './BadgeRow';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white min-h-[calc(100vh-4rem)] flex items-center">
      <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between gap-16 px-4 lg:px-8">
        {/* copy */}
        <div className="text-center md:text-left flex-1">
          <h1 className="font-semibold text-brand mb-8 leading-tight text-[2.75rem] md:text-[4rem]">
            {t('hero.title1')}
            <br />
            {t('hero.title2')}
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-md md:max-w-none">
            {t('hero.desc')}
          </p>

          <BadgeRow className="justify-center md:justify-start gap-4" />
        </div>

        {/* mascot */}
        <motion.div
          className="flex-shrink-0"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <div className="w-full max-w-xs md:max-w-lg lg:max-w-xl select-none mx-auto">
            <ResponsiveImage
              srcBase="/images/mascot-hero"
              alt={t('hero.mascotAlt')}
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
